import BurgerMenu from '@monofront/design-system/visuals/Icons/Old/BurgerMenu';
import Close from '@monofront/design-system/visuals/Icons/Old/Close';
import { useEffect } from 'react';
import { useTranslations } from 'next-intl';
import Link from 'next/link';

interface IMegaMenuTriggerProps {
  isMegaMenuOpen: boolean;
  setIsMegaMenuOpen: () => void;
}

const MegaMenuTrigger: React.FC<IMegaMenuTriggerProps> = ({
  isMegaMenuOpen,
  setIsMegaMenuOpen,
}) => {
  const tCatalog = useTranslations('Catalog');

  useEffect(() => {
    if (isMegaMenuOpen) {
      // force focus when mega menu is opened
      document
        ?.getElementById('mega-menu-nav')
        ?.focus({ preventScroll: false });
    }
  }, [isMegaMenuOpen]);

  return (
    <li className={`mega-menu-trigger ${isMegaMenuOpen ? ' active' : ''}`}>
      <Link
        href="/collections-list"
        // prevent getting caught by screen readers, still allows below
        // button to take focus and to navigate without JS enabled
        tabIndex={-1}
        onClick={(e) => {
          e.preventDefault();
          e.nativeEvent.stopImmediatePropagation();
        }}
      >
        <button
          className="tw-lf-button-clear tw-px-2"
          aria-expanded={isMegaMenuOpen}
          aria-controls="mega-menu-nav"
          onClick={setIsMegaMenuOpen}
          type="button"
          // prevent useOnClickOutside hook to be triggered with this button - bigup JF for this help
          onMouseDown={(event) => event.stopPropagation()}
          onTouchStart={(event) => event.stopPropagation()}
          data-testid="MegaMenuTrigger-button"
        >
          <span className="tw-flex tw-flex-row tw-items-center tw-py-2 tw-transition-all hover:tw-text-blue-600">
            <span className="tw-flex">
              {isMegaMenuOpen ? (
                <Close width={16} height={16} />
              ) : (
                <BurgerMenu width={16} height={16} />
              )}
            </span>
            <span className="tw-lf-body-bold-md tw-ml-4 tw-hidden tw-text-nowrap desktop:tw-inline">
              {tCatalog('allSections')}
            </span>
          </span>
        </button>
      </Link>
    </li>
  );
};

export default MegaMenuTrigger;
